import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, stack, accent, summary, href, isPlaceholder }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <a
        className={`proj-imgbx${accent ? ` ${accent}` : ""}${isPlaceholder ? " is-placeholder" : ""}`}
        href={href || "#projects"}
        target="_blank"
        rel="noreferrer"
      >
        <img src={imgUrl} alt={title} />
        <div className="proj-meta">
          {stack?.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          {summary ? <p>{summary}</p> : null}
        </div>
      </a>
    </Col>
  )
}
